import React from 'react';

import { CopyOutlined } from '@ant-design/icons';
import { Button, message, Modal as AntdModal, Typography } from 'antd';

import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';

import './ModalErrorMessage.less';

interface ModalErrorMessageProps {
  visible: boolean;
  close: () => void;
  errorMessage?: string | null;
  title?: string;
}

function ModalErrorMessage({
  visible,
  close,
  errorMessage,
  title = "Message d'erreur",
}: ModalErrorMessageProps): React.ReactElement {
  const [copyLoading, setCopyLoading] = React.useState(false);
  const handleCopyToClipboard = async (): Promise<void> => {
    try {
      setCopyLoading(true);
      await navigator.clipboard.writeText(errorMessage || '');
      void message.success('Message copié dans le presse-papier');
    } catch (error) {
      void message.error('Erreur lors de la copie');
    } finally {
      setCopyLoading(false);
    }
  };

  return (
    <AntdModal
      title={title}
      open={visible}
      onCancel={close}
      footer={[
        <Button
          key="copy"
          icon={<CopyOutlined />}
          onClick={handleCopyToClipboard}
          disabled={copyLoading}
          type="primary"
        >
          Copier
        </Button>,
        <Button key="close" onClick={close}>
          Fermer
        </Button>,
      ]}
      width={BaseModalWidthUtils.xLargeWidth}
      destroyOnClose={true}
      maskClosable={true}
      className="modalErrorMessage"
    >
      <Typography.Paragraph
        className="errorMessageContent"
        role="textbox"
        aria-label="Message d'erreur complet"
        aria-readonly="true"
        tabIndex={0}
      >
        {errorMessage}
      </Typography.Paragraph>
    </AntdModal>
  );
}

export default ModalErrorMessage;
